export default __webpack_public_path__ + "static/media/samsungLogo.9377f9b1.png";